import { render, staticRenderFns } from "./ManageRefunds.vue?vue&type=template&id=2795ae02&scoped=true"
import script from "./ManageRefunds.vue?vue&type=script&lang=js"
export * from "./ManageRefunds.vue?vue&type=script&lang=js"
import style0 from "./ManageRefunds.vue?vue&type=style&index=0&id=2795ae02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2795ae02",
  null
  
)

export default component.exports